import { useVeltClient } from '@veltdev/react';
import React, { useEffect } from 'react'

function Header() {

    const { client } = useVeltClient();

    useEffect(() => {
        if (client) {
            handleLogin();
        }
    }, [client]);

    async function generateVeltAuthToken(userId: string) {
        const url = "https://generatedemoauthtoken-luq227lwva-uc.a.run.app";
        const body = {
            data: {},
        };

        try {
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(body),
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            return data?.result?.data?.token;
        } catch (error) {
            console.error("Error:", error);
        }
    }      

    /**
     * Call this method when user logs in and client is available
     */
    const handleLogin = async () => {
        const user = {
            userId: '26616fac071043938a5eb5858bc1af26',
            name: 'John Smith',
            photoUrl: 'https://snippyly.com/assets/avatars/avatar-panda.svg',
            email: 'john@trysnippyly.com',
            plan: 'free',
            groupId: '',
            contacts: [
                {
                    userId: '2',
                    name: 'Maria Garcia',
                    email: 'maria@trysnippyly.com',
                },
                {
                    userId: '3',
                    name: 'Sarah Wilson',
                    email: 'sarah@trysnippyly.com',
                }
            ]
        }
        const authToken = await generateVeltAuthToken(user.userId);
        client.identify(user, {
            replaceContacts: true,
            authToken: authToken
        });
    }

    return (
        <div>
            {/* Header UI here... */}
        </div>
    )
}

export default Header;